
import Vue from 'vue'
import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'

// Email pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default Vue.extend({
  name: 'Login',
  data(){
    return {
      email: '',
      password: '',
      loginLoading: false,
      loginFailed: false
    }
  },
  computed: {
    organization(){ return this.$store.getters.organization }
  },
  async mounted(){
    if (this.organization?.id && this.$store.getters.isOrgSunsetActive) {
      this.$router.replace({ name: 'OrganizationSunset', params: { organizationId: this.organization.id } })
    }
  },
  methods: {
    async handleLogin(e: Event){
      e.preventDefault()

      if (this.$store.getters.isOrgSunsetActive) {
        return this.$router.replace({
          name: 'OrganizationSunset',
          params: { organizationId: this.organization.id },
        })
      }

      this.loginLoading = true

      try {
        await this.$store.dispatch('signInUser', {email: this.email, password: this.password})
        this.loginFailed = false
        this.loginLoading = false
        this.$router.push(`/${this.organization.id}`)
      } catch (error) {
        console.error(error)
        this.loginFailed = true
        this.loginLoading = false
      }
    }
  },
  components: {
    UiCard,
    UiButton
  }
})
